<template>

  <div id="app">

    <app-header />

    <div v-if="auth.user == null">
      <transition name="fade" mode="out-in" appear-class="fade">
        <router-view name="entry" v-if="auth.user == null"></router-view>
      </transition>
    </div><!-- logged out view -->

    <div v-if="auth.user !== null">
      <transition name="fade" mode="out-in" appear-class="fade">
        <router-view v-if="auth.user !== null"></router-view>
      </transition>
    </div><!-- logged in view -->

  </div><!-- app -->

</template>

<script>
  import AppHeader from './components/Header'
  import { authService } from './helpers/helpers'

  export default {
    name: 'app',

    data () {
      return {
        auth: authService
      }
    },

    components: {
      AppHeader
    }
  }
</script>

<style>

  @font-face {
    font-family: 'Avenir';
    src: url('../static/fonts/avenir-next-regular.woff');
  }

  @font-face {
    font-family: 'Avenir Medium';
    src: url('../static/fonts/avenir-next-medium.woff');
  }

  html,
  body,
  #app {
    width:  100%;
    height:  100%;
  }

  body {
    margin:  0;
    padding:  0;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Avenir Medium', Helvetica, Arial, sans-serif;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

</style>



// WEBPACK FOOTER //
// App.vue?5fc5b5b6